export const TABLES = {
  settings: 'settings_gwaacademy',
  content: 'academy_content_gwaacademy',
  evergreenContent: 'content_evergreen_gwaacademy',
  contentHistory: 'content_history_gwaacademy',
  students: 'students_gwaacademy',
  departments: 'departments_gwaacademy',
  sessions: 'sessions_gwaacademy',
  runs: 'runs_gwaacademy',
  enrollments: 'enrollments_gwaacademy',
  passes: 'passes_gwaacademy',
  labPartners: 'lab_partners_gwaacademy',
  selfLetters: 'self_letters_gwaacademy',
  sessionEntries: 'session_entries_gwaacademy',
  waitlist: 'waitlist_gwaacademy',
  webhookLogs: 'webhook_logs_gwaacademy',
};